export const CustomChevronLeft = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentcolor" class="fil-icon"><polyline points="17 21.5 7 12 17 2.5"/></svg>`;
export default CustomChevronLeft;